export default "__VITE_ASSET__5fRak$lJ__"